var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("links.printModal.title")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("links.printModal.prompt")) +
                "\n        "
            ),
            _vm.collections.length < 10
              ? _c(
                  "ul",
                  _vm._l(_vm.collections, function(collection) {
                    return _c("li", [_vm._v(_vm._s(collection.name))])
                  }),
                  0
                )
              : _c("div", [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("links.printModal.count", {
                          count: _vm.collections.length
                        })
                      )
                    )
                  ])
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "row align-items-center" }, [
              _c("div", { staticClass: "col-2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("links.printModal.format")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.columns,
                        expression: "columns"
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.columns = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "1" } }, [_vm._v("Z79x87")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [_vm._v("A4")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "3" } }, [_vm._v("Z90x55")])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.generateQR()
                  }
                }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("btnPrintQr")) + "\n        "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }